import {useMutation} from '@apollo/client';
import {UPDATE_PHARMACY} from "../pharmacyTypeDefs";

export const useMutationUpdatePharmacy = (options?: any): any => (
  useMutation(UPDATE_PHARMACY, options)
);
